import axios from 'axios'
// import commovisconfig from '@/services/config'
// import {use} from "chai";

const getDefaultState = () => {
    return {

    }
};

const state = getDefaultState();

const getters = {

}

const actions = {

    async createUsers({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            const users = Array.isArray(payload) ? payload : payload.users;
            const emailTemplateId = Array.isArray(payload) ? null : (payload.emailTemplateId || null);

            let payloadAPI = {
                NewUsers: users,
            }

            if (emailTemplateId) {
                payloadAPI.EmailTemplateId = emailTemplateId;
            }

            const response = await axios.post('/v2/create-users', payloadAPI, config);

            return response.data.createdUsers || [];

        }
        catch (err) {
            // insufficientCredits gets its own translated message in UserManagement.vue
            if (!err.response?.data?.insufficientCredits) {
                dispatch('notifications/addNotification', {
                    type: 'error',
                    message: 'Users failed to be created'
                }, {root: true});
            }
            throw err;
        }
    },

    async getUsersByRole({ commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                "Roles": payload.Roles
            }

            const response = await axios.post('/v2/list-users-by-role', payloadAPI, config);
            // commit('setExistingUsers', response.data.usersList);

            return response.data.users;

        }
        catch (err) {
            throw new Error(err);
        }


    },

    // async getExistingUsers({ commit, dispatch, rootState}) {
    //     axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    //     try {
    //         let config = {
    //             headers: {
    //                 Authorization: rootState.auth.bearer
    //             },
    //         };
    //
    //         let payload = {
    //
    //         }
    //
    //         const response = await axios.post('/v2/list-users', payload, config);
    //         // commit('setExistingUsers', response.data.usersList);
    //         response.data.usersList.forEach((user) => {
    //             user.IsEdit = false;
    //         });
    //
    //         return response.data.usersList;
    //
    //     }
    //     catch (err) {
    //         throw new Error(err);
    //     }
    // },

    async getExistingUsers({ commit, dispatch, rootState}) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer,
                },
            };

            let allUsers = [];
            let nextToken = null;

            do {
                let payload = { nextToken };
                const response = await axios.post('/v2/list-users', payload, config);

                if (response.data.usersList) {
                    allUsers.push(...response.data.usersList);
                }

                nextToken = response.data.nextToken || null; // Update nextToken for the next request

            } while (nextToken); // Continue fetching if nextToken exists

            // commit('setExistingUsers', allUsers);
            return allUsers;

        }
        catch (err) {
            throw new Error(err);
        }
    },

    async streamExistingUsers({ rootState }, { onBatch }) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
        try {
            const config = {
                headers: { Authorization: rootState.auth.bearer },
            };

            let nextToken = null;

            do {
                const response = await axios.post('/v2/list-users', { nextToken }, config);

                if (response.data.usersList && response.data.usersList.length > 0) {
                    onBatch(response.data.usersList);
                }

                nextToken = response.data.nextToken || null;

            } while (nextToken);

        } catch (err) {
            throw new Error(err);
        }
    },


    async getUsersLinkedToCurrentUser({ commit, dispatch, rootState }, data) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payload = {

            };

            const response = await axios.post('/v2/get-participants-linked-to-author', payload, config);

            return response.data.linkedUsers;
            // commit('SET_LINKED_USERS', response.data.linkedUsers);

        }
        catch (err) {
            throw new Error(err);
        }
    },

    async deleteUsers({ commit, dispatch, rootState }, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            }

            let payloadAPI = {
                "DeletedUsers": payload
            }

            await axios.post('/v2/delete-users', payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'User successfully deleted'
            }, {root: true});

            return true;

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'User failed to be deleted'
            }, {root: true});

            return false;
        }
    },

    async updateUsers({commit, dispatch, rootState}, payload) {

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            }

            let payloadAPI = {
                "UpdatedUsers": payload,
            };

            await axios.post(`/v2/tenant-admin-update-users`, payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'User successfully updated'
            }, {root: true});

        }
        catch (err) {
            // insufficientCredits (role change billing) gets its own translated message in UserManagement.vue
            if (!err.response?.data?.insufficientCredits) {
                dispatch('notifications/addNotification', {
                    type: 'error',
                    message: 'User failed to be updated'
                }, {root: true});
            }
            throw err;
        }
    },

    async verifyUserEmail({rootState}) {

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            }

            let payload = {

            }

            await axios.post('/v2/user/verifyUserEmail', payload, config);

        }
        catch (err) {
        }
    },

    async checkExistingUsers({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                UsersEmails: payload.UsersEmails,
            }

            let response = await axios.post('/v2/check-existing-users', payloadAPI, config);

            return response.data.checkedUsers;

        }
        catch (err) {

        }
    },

    async alignUsersExpirationDate({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                Users: payload.Users,
            }

            await axios.post('/v2/align-users-expiration-date', payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Users expiration date successfully updated'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Users expiration date failed to be aligned'
            }, {root: true});
        }

    },

    // bills each user individually at their own real app role, unlike alignUsersExpirationDate
    async alignJourneyUsersExpirationDate({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                Users: payload.Users,
            }

            await axios.post('/v2/align-journey-users-expiration-date', payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Users expiration date successfully updated'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Users expiration date failed to be aligned'
            }, {root: true});
        }

    },

    // extends each selected user's expiration date to one year from today, billed at their own real app role.
    // pass AlwaysChargeTenant: true when calling from Admin User Management: this routes to the admin-only
    // endpoint (enforced by its authorizer, not by anything in the request body) so the tenant is billed even
    // when its paymentOption is TF; Journey Card user management omits it, following paymentOption as usual
    async extendUsersAccounts({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                Users: payload.Users,
            }

            const endpoint = payload.AlwaysChargeTenant ? '/v2/admin-extend-users-accounts' : '/v2/extend-users-accounts';

            await axios.post(endpoint, payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Users accounts successfully extended'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Users accounts failed to be extended'
            }, {root: true});
        }

    },

    async resendUsersTemporaryPassword({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {

            };

            if (!payload.IsAdminAllUsers) {
                payloadAPI.UsersEmails = payload.UsersEmails;
            }

            if (payload.EmailTemplateId) {
                payloadAPI.EmailTemplateId = payload.EmailTemplateId;
            }

            await axios.post('/v2/resend-users-temporary-password', payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'User temporary password successfully resend'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'User temporary password failed to resend'
            }, {root: true});
        }
    },

    resetState({ commit }) {
        commit('RESET_STATE');
    },
}

const mutations = {

    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
